import { axios } from "@/libraries/axios";
import type {
	GetCalendarDetailResponse,
	GetCalendarInfoResponse,
	GetCalendarsResponse,
} from "@/types/calendar";
import type { AxiosRequestConfig } from "axios";

class CalendarService {
	/**
	 *
	 * @param startDate - Start Date, 01-12-2025, DD-MM-YYYY
	 */
	async getCalendars(startDate: string, config?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetCalendarsResponse>(
				`/api/v1/calendars/${startDate}`,
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	/**
	 *
	 * @param startDate - Start Date, 01-12-2025, DD-MM-YYYY
	 */
	async getCalendarEvents(config?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetCalendarDetailResponse>(
				"/api/v1/calendars/detail",
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async getCalendarInfo(config?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetCalendarInfoResponse>(
				"/api/v1/calendars",
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const calendarService = Object.freeze(new CalendarService());
